import { ApplicationRef, Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalResizeService {

  constructor(private ngZone: NgZone, private appRef: ApplicationRef) {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('resize', () => {
        this.ngZone.run(() => {
          this.appRef.tick(); // Triggers global change detection
        });
      });
    });
  }
}
